import React, { useState } from "react";
import { Box, TextField } from "@mui/material/";
import LoadingButton from "@mui/lab/LoadingButton";
import { strings } from "../../../../../common/i18n";
import SendIcon from "@mui/icons-material/Send";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { logToSentry } from "../../../../../config/Sentry";

/**
 * Note Input Component
 */
const NoteInput = ({ setNoteType, historyNote, setHistoryNote, onSubmit }) => {
    const [loading, setLoading] = useState(false);
    const handleNoteSubmit = async () => {
        if (loading) return; // Prevent multiple clicks
        try {
            setLoading(true); // disable button immediately
            await onSubmit(); // your async request
        } catch (error) {
            console.error(error);
            logToSentry("On exclusion submit:", { error });
        } finally {
            setLoading(false);
            setHistoryNote("");
        }
    };

    return (
        <Box display="flex" gap={1.5} alignItems="center">
            <TextField
                fullWidth
                size="small"
                placeholder={strings("messages.enterComment")}
                value={historyNote}
                onChange={(e) => {
                    setNoteType("history");
                    setHistoryNote(e.target.value);
                }}
                sx={{
                    backgroundColor: "#f9f9f9",
                    borderRadius: 1
                }}
            />

            <LoadingButton
                variant="contained"
                disabled={historyNote.trim() === ""}
                disableElevation
                sx={{
                    minWidth: 72,
                    height: 36,
                    fontWeight: 600,
                    textTransform: "none"
                }}
                endIcon={<EditNoteIcon />}
                onClick={handleNoteSubmit}
            >
                {strings("add")}
            </LoadingButton>
        </Box>
    );
};

export default NoteInput;
